import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders,
    JsonpClientBackend,
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { Subject, Observable } from "rxjs";
//import { NodoArbolMenu } from "src/app/asistente-en-linea/components/asistencia-menu-arbol/models/nodo-arbol-menu";
import { EditingMode } from "../../models/editingMode";
import { AuthService } from '../../auth/auth.service';

const endpoint = environment.apiBaseUrl + '/admin/destinatarios';

const httpOptions = {
    headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/octet-stream'
    }),
};

@Injectable({
    providedIn: "root",
})
export class DestinatariosService {

    constructor(private httpClient: HttpClient, private authService: AuthService) {

    }

    private extractData(res: Response) {
        const body = res;
        return body || {};
    }

    //HTTP
    //Cargar el árbol y las preguntas frecuentes con sus ids.
    loadDestinatariosMenu(habilitado) {
        return this.httpClient.get<any>(endpoint + `/list?habilitado=${habilitado}`).pipe(map(this.extractData));
    }

    lloadDestinatarioByID(idDestinatario) {
        return this.httpClient.get<any>(endpoint + `/display/${idDestinatario}`).pipe(map(this.extractData));
    }

    salirAdministrador() {
        this.authService.logout();
    }

    agregarDestinatario(codigo, descripcion, titulo, targetType, target, updateUser, horaInicio, horaFin) {
        //debugger
        const params = {
            codigo: codigo,
            descripcion: descripcion,
            titulo: titulo,
            targetType: targetType,
            target: target,
            userName: updateUser,
            horaInicio: horaInicio,
            horaFin: horaFin,
        }
        return this.httpClient.post(`${endpoint}/add`, params)
    }

    actualizarDestinatario(idDestinatario, codigo, descripcion, titulo, targetType, target, updateUser, habilitado, horaInicio, horaFin) {
        const params = {
            idDestinatario: idDestinatario,
            codigo: codigo,
            descripcion: descripcion,
            titulo: titulo,
            targetType: targetType,
            target: target,
            userName: updateUser,
            habilitado: habilitado,
            horaInicio: horaInicio,
            horaFin: horaFin,
        }
        return this.httpClient.post(`${endpoint}/update`, params)
    }

    deleteDestinatario(id) {
        const params = {
            id
        }
        return this.httpClient.post(`${endpoint}/delete/${id}`, params);
    }

    validarVinculacion(id) {
        return this.httpClient.get<any>(endpoint + `/validarVinculacion/${id}`).pipe(map(this.extractData));
    }
}
